import { supabase } from "./supabase";
import type { TeamMember } from "./types";

export async function listTeamMembers(): Promise<TeamMember[]> {
  const { data, error } = await supabase.rpc("list_team_members");
  if (error) throw new Error(error.message);
  return (data ?? []) as TeamMember[];
}

export interface InviteRecruiterParams {
  email: string;
  companyIds: string[];
}

export async function inviteRecruiter(
  params: InviteRecruiterParams
): Promise<{ userId: string; isNewUser: boolean; grantedCompanies: number }> {
  const { data, error } = await supabase.functions.invoke<{
    userId: string;
    isNewUser: boolean;
    grantedCompanies: number;
  }>("invite-recruiter", {
    body: {
      ...params,
      redirectTo: window.location.origin,
    },
  });
  if (error) throw new Error(error.message);
  if (!data) throw new Error("Respuesta vacía");
  return data;
}

/** Otorga acceso de un usuario existente a una empresa. */
export async function grantAccess(
  userId: string,
  companyId: string
): Promise<void> {
  const { error } = await supabase
    .from("recruiter_access")
    .upsert(
      { user_id: userId, company_id: companyId },
      { onConflict: "user_id,company_id" }
    );
  if (error) throw new Error(error.message);
}

/** Revoca acceso de un usuario a una empresa. */
export async function revokeAccess(
  userId: string,
  companyId: string
): Promise<void> {
  const { error } = await supabase
    .from("recruiter_access")
    .delete()
    .eq("user_id", userId)
    .eq("company_id", companyId);
  if (error) throw new Error(error.message);
}

/** Toggle admin status (solo otros admins lo pueden invocar via RLS). */
export async function setAdmin(userId: string, makeAdmin: boolean): Promise<void> {
  if (makeAdmin) {
    const { error } = await supabase
      .from("app_admins")
      .upsert({ user_id: userId }, { onConflict: "user_id" });
    if (error) throw new Error(error.message);
  } else {
    const { error } = await supabase
      .from("app_admins")
      .delete()
      .eq("user_id", userId);
    if (error) throw new Error(error.message);
  }
}
